/**
 * Indicate that we changed of page.
 * @type {string}
 */
export const CHANGE_ACTUAL_PAGE = "CHANGE_ACTUAL_PAGE";
